import Vue from 'vue';
import * as VeeValidate from 'vee-validate';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';

import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

Vue.config.productionTip = false;

Vue.use(VeeValidate, {
  events: 'change|blur',
});

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);

Vue.prototype.$eventHub = new Vue();

new Vue({
  router,
  vuetify,
  render: h => h(App),
}).$mount('#app');
